import React, { useEffect, useState } from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';
import useStateRef from 'react-usestateref';
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
import Helper from '../Helper';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Loader from '../Loader/Loader';
import { Link } from 'react-router-dom';
import OrderSummary from './OrderSummary';
import LivingCalendarModal from './LivingCalendarModal';
import NonLivingCalendarModal from './NonLivingCalendarModal';
import SpecialCalendarModal from './SpecialCalendarModal';

function CheckoutDelivery({ containerObject, templateName, contentId, dataZone }) {

    const [deliveryDetails, setdeliveryDetails, deliveryDetailsRef] = useStateRef('');
    const [specialProductItem, setSpecialProductItem, specialProductItemRef] = useStateRef('')
    const [livingProductItem, setLivingProductItem, livingProductItemRef] = useStateRef('')
    const [nonLivingProductItem, setNonLivingProductItem, nonLivingProductItemRef] = useStateRef('')
    const [selecteCurrentMethod, setSelecteCurrentMethod, selecteCurrentMethodRef] = useStateRef('Standard Ground');
    const [previousShippingMethodState, setPreviousShippingMethodState, previousShippingMethodStateRef] = useStateRef('Standard Ground')
    const [formattedCurrentDate, setFormattedCurrentDate, formattedCurrentDateRef] = useStateRef('');
    const [dateTriggered, setDateTriggered] = useState(true);
    const [detailFlag, setDetailFlag] = useState(true);
    const [orderSummaryDetails, setOrderSummaryDetails, orderSummaryDetailsRef] = useStateRef("");
    const [myOrderBoxFix, setMyOrderBoxFix] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [shippingOptionCalendar, setShippingOptionCalendar, shippingOptionCalendarRef] = useStateRef('');
    const [shippingOptionCalendarPrevious, setShippingOptionCalendarPrevious] = useState('');

    const [selecteNonLivingMethod, setSelecteNonLivingMethod, selecteNonLivingMethodRef] = useStateRef('');
    const [selectedShipGroupMethod, setSelectedShipGroupMethod, selectedShipGroupMethodRef] = useStateRef('');
    const [shipGroupFlag, setShipGroupFlag] = useState(true);
    const history = useHistory();

    const specialProduct = []
    const livingProduct = []
    const nonLivingProduct = []
    const allLivingMaterialItems = []
    const allSpecialItems = []

    const [search, setSearch, searchRef] = useStateRef("");

    // living
    const [livingMaterialItems, setLivingMaterialItems] = useState([]);
    const [selectedItem, setSelectedItem, selectedItemRef] = useStateRef('');
    const [selectedDate, setSelectedDate, selectedDateRef] = useStateRef(null);
    const [currentDate, setCurrentDate] = useState('');
    const [livingNotAvailableMethod, setLivingNotAvailableMethod, livingNotAvailableMethodRef] = useStateRef('');
    const [selectedAlternateDate, setSelectedAlternateDate, selectedAlternateDateRef] = useStateRef('');
    const [formattedDateForLiving, setFormattedDateForLiving] = useState('');
    const [livingMapDate, setLivingMapDate, livingMapDateRef] = useStateRef('')
    const [selecteLivingMethod, setSelecteLivingMethod, selecteLivingMethodRef] = useStateRef('');
    const [shipSeprateFlag, setShipSeprateFlag] = useState(true);
    const [showDate, setShowDate, showDateRef] = useStateRef(new Date());
    const [livingFlag, setLivingFlag, livingFlagRef] = useStateRef(false);


    // living and special without group name
    const [calendarWithoutGroupName, setCalendarWithoutGroupName, calendarWithoutGroupNameRef] = useStateRef('');
    const [currentcommerceItemId, setCurrentcommerceItemId] = useState('');
    const [currentSkuId, setCurrentSkuId] = useState('');
    const [currentquantity, setCurrentquantity] = useState('');
    const [selectedShipGroupId, setSelectedShipGroupId] = useState('');

    // non living
    const [nonLivingMapDate, setNonLivingMapDate, nonLivingMapDateRef] = useStateRef('')
    const [selectedItemNonLiving, setSelectedItemNonLiving, selectedItemNonLivingRef] = useStateRef('');
    const [selectedDateNonLivingItem, setSelectedDateNonLivingItem, selectedDateNonLivingItemRef] = useStateRef(null);
    const [currentDateNonLiving, setCurrentDateNonLiving] = useState('');
    const [formattedDateForNonLiving, setFormattedDateForNonLiving] = useState('');
    const [showDateNonLiving, setShowDateNonLiving, showDateNonLivingRef] = useStateRef(new Date());
    //special
    const [selectedItemSpecial, setSelectedItemSpecial, selectedItemSpecialRef] = useStateRef('');
    const [selectedDateSpecialItem, setSelectedDateSpecialItem, selectedDateSpecialItemRef] = useStateRef(null);
    const [currentDateSpecial, setCurrentDateSpecial] = useState('');
    const [specialNotAvailableMethod, setSpecialNotAvailableMethod, specialNotAvailableMethodRef] = useStateRef('');
    const [specialAvailableMethod, setSpecialAvailableMethod, specialAvailableMethodRef] = useStateRef('');
    const [specialAlternateDate, setSpecialAlternateDate, specialAlternateDateRef] = useStateRef('');
    const [shippingOptionCalendarSpecial, setShippingOptionCalendarSpecial, shippingOptionCalendarSpecialRef] = useStateRef('');
    const [shippingSpecialCalendarPrevious, setShippingSpecialCalendarPrevious] = useState('');
    const [isBackOrderSpecial, setIsBackOrderSpecial, isBackOrderSpecialRef] = useStateRef('');
    const [showDateSpecial, setShowDateSpecial, showDateSpecialRef] = useStateRef(new Date());
    var fieldNames = ["firstName", "lastName", "emailAddress", "phoneNumber", "companyName", "address1", "address2", "postalCode","city","state"]

    useEffect(()=>{
        setSearch(window.location.pathname)
        setLocalStorageData(fieldNames)
    },[])


    function setLocalStorageData(fields) {
        fields.map((oneData)=>{
            localStorage.removeItem(oneData);
        })
    }

    useEffect(() => {
        if(containerObject && containerObject["@type"] == "CheckoutDelivery" && searchRef.current == "/checkout/delivery") {
        setIsLoading(true)
        if (detailFlag) {
            const deliveryParam = window.location.search
            console.log('deliveryParam----', deliveryParam)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/delivery-details/${deliveryParam === '?create=true' ? 'true' : 'false'}`, {
                method: 'GET'
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setIsLoading(false)
                        var deliveryDetailRes = (JSON.parse(res.response)).response
                        deliveryDetailRes.forEach(item => {
                            setdeliveryDetails(item)
                            console.log("setdeliveryDetails", deliveryDetailsRef.current)
                        });

                        getOrderSummaryDetails();
                        if(document.getElementById('checkoutDelivery').classList.contains('pe-none')){
                        document.getElementById('checkoutDelivery').classList.remove('pe-none')
                        }
                        if(!document.getElementById('checkoutDelivery').classList.contains('pe-auto')){
                        document.getElementById('checkoutDelivery').classList.add('pe-auto')
                        }
                        
                    } else {
                        setIsLoading(false)
                    }
                })

        }
        setDetailFlag(false)
    }
    }, [detailFlag])

    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;
    }


    function handleCallBackOrderSummary() {
        getOrderSummaryDetails();
    }
    const getOrderSummaryDetails = async () => {
        const body = {
            "isReviewPage": false,
            "isShippingPage": false,
            "requiredReprice": true
        }
        var orderSummary = await Helper.getOrderSummary(body);
        setOrderSummaryDetails(orderSummary);
    }

    useEffect(() => {
        if (dateTriggered) {
            const date = new Date();
            // Check if current day is Sunday (0) or Saturday (6)
            const isWeekend = date.getDay() === 0 || date.getDay() === 6;
            if (selecteCurrentMethodRef.current === 'Standard Ground') {
                if (!isWeekend) {
                    date.setDate(date.getDate() + 3);
                } else {
                    date.setDate(date.getDate() + 5);
                }

            }
            if (selecteCurrentMethodRef.current === '2 Day Air') {
                if (!isWeekend) {
                    date.setDate(date.getDate() + 2);
                } else {
                    date.setDate(date.getDate() + 4);
                }

            }
            if (selecteCurrentMethodRef.current === 'Overnight') {
                if (!isWeekend) {
                    date.setDate(date.getDate() + 1);
                } else {
                    date.setDate(date.getDate() + 2);
                }

            }

            const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
            const year = date.getFullYear();
            const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            const milliseconds = date.getMilliseconds();
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
            setFormattedCurrentDate(formattedDate)
        }
        setDateTriggered(false)
    }, [dateTriggered])

    useEffect(() => {
        if (deliveryDetailsRef.current) {

            if (deliveryDetailsRef.current) {

                // special product
                { deliveryDetailsRef.current?.dropShipItems ? specialProduct.push(deliveryDetailsRef.current.dropShipItems) : "" }
                { deliveryDetailsRef.current?.groundOnlyItems ? specialProduct.push(deliveryDetailsRef.current.groundOnlyItems) : "" }
                { deliveryDetailsRef.current?.softGoodsItems ? specialProduct.push(deliveryDetailsRef.current.softGoodsItems) : "" }
                { deliveryDetailsRef.current?.backOrderLivingMaterialItems ? specialProduct.push(deliveryDetailsRef.current.backOrderLivingMaterialItems) : "" }
                { deliveryDetailsRef.current?.rtsProductsItems ? specialProduct.push(deliveryDetailsRef.current.rtsProductsItems) : "" }
    
                // living product
                { deliveryDetailsRef.current?.livingMaterialItems ? livingProduct.push(deliveryDetailsRef.current.livingMaterialItems) : "" }
                { deliveryDetailsRef.current?.specialLivingMaterialItems ? livingProduct.push(deliveryDetailsRef.current.specialLivingMaterialItems) : "" }
    
                // non-living product
                { deliveryDetailsRef.current?.nonLivingItems ? nonLivingProduct.push(deliveryDetailsRef.current.nonLivingItems) : "" }
    
    
                if (nonLivingProduct.length > 0) {
                    setNonLivingProductItem(nonLivingProduct)
                }
                {
                    livingProduct.length > 0 && livingProduct.forEach(item => {
                        allLivingMaterialItems.push(item)
                    })
                }
                if (allLivingMaterialItems.length > 0) {
                    setLivingProductItem(allLivingMaterialItems)
                }
    
                {
                    specialProduct.length > 0 && specialProduct.forEach(item => {
                        allSpecialItems.push(item)
                    })
                }
                if (allSpecialItems.length > 0) {
                    setSpecialProductItem(specialProduct)
                }
                populateDataLayer()
                
            }


            if (deliveryDetailsRef.current?.nonLivingMaterialItemShippingMap) {
                if (deliveryDetailsRef.current.nonLivingMaterialItemShippingMap?.shipImmediateChecked == "true") {
                    setSelecteNonLivingMethod('shipImmediate')
                    if (shipGroupFlag) {
                        if (deliveryDetailsRef.current.nonLivingMaterialItemShippingMap?.shipMethodForNonLivingItem === 'Standard Ground') {
                            setSelectedShipGroupMethod('Standard Ground')
                            setSelecteCurrentMethod('Standard Ground')
                        } else if (deliveryDetailsRef.current.nonLivingMaterialItemShippingMap?.shipMethodForNonLivingItem === '2 Day Air' || 
                        deliveryDetailsRef.current.nonLivingMaterialItemShippingMap?.shipMethodForNonLivingItem === 'Second Day Air') {
                            setSelectedShipGroupMethod('2 Day Air')
                            setSelecteCurrentMethod('2 Day Air')
                        } else {
                            setSelectedShipGroupMethod('Overnight')
                            setSelecteCurrentMethod('Overnight')
                        }
                    }
                }
                if (deliveryDetailsRef.current?.nonLivingMaterialItemShippingMap?.shipLaterChecked == "true") {
                    setSelecteNonLivingMethod('shipLater')
                }

                if (deliveryDetailsRef.current?.nonLivingMaterialItemShippingMap) {
                    if (deliveryDetailsRef.current.nonLivingMaterialItemShippingMap?.comDate) {
                        var dateObject = new Date(deliveryDetailsRef.current.nonLivingMaterialItemShippingMap.comDate);
                        var day = dateObject.getDate();
                        var month = dateObject.getMonth() + 1;
                        var year = dateObject.getFullYear();
                        day = day < 10 ? '0' + day : day;
                        month = month < 10 ? '0' + month : month;
                        var formattedDate = month + '/' + day + '/' + year;
                        setFormattedDateForNonLiving(formattedDate)
                    }
                    setNonLivingMapDate(deliveryDetailsRef.current.nonLivingMaterialItemShippingMap)
                }
            }

            if (deliveryDetailsRef.current?.livingMaterialItemShippingMap) {

                if (deliveryDetailsRef.current.livingMaterialItemShippingMap?.sameDaychecked) {
                    setSelecteLivingMethod('shipAllTogether')
                    setShipSeprateFlag(false)
                }
                if (deliveryDetailsRef.current.livingMaterialItemShippingMap?.diffDaychecked) {
                    setSelecteLivingMethod('shipSeparately')
                    setShipSeprateFlag(true)
                    setLivingFlag(true)
                }

                if (deliveryDetailsRef.current.livingMaterialItemShippingMap?.comDate) {
                    var dateObject = new Date(deliveryDetailsRef.current.livingMaterialItemShippingMap.comDate);
                    var day = dateObject.getDate();
                    var month = dateObject.getMonth() + 1;
                    var year = dateObject.getFullYear();
                    day = day < 10 ? '0' + day : day;
                    month = month < 10 ? '0' + month : month;
                    var formattedDate = month + '/' + day + '/' + year;
                    setFormattedDateForLiving(formattedDate)
                }
                setLivingMapDate(deliveryDetailsRef.current.livingMaterialItemShippingMap)
            }

            if (deliveryDetailsRef.current?.livingMaterialItems || deliveryDetailsRef.current?.specialLivingMaterialItems) {

                if (deliveryDetailsRef.current.livingMaterialItems && deliveryDetailsRef.current.specialLivingMaterialItems) {
                    const living = deliveryDetailsRef.current.livingMaterialItems;
                    const special = deliveryDetailsRef.current.specialLivingMaterialItems;
                    const mergedItems = [
                        ...living,
                        ...special
                    ];
                    setLivingMaterialItems(mergedItems)
                } else if (deliveryDetailsRef.current.livingMaterialItems) {
                    const onlyLiving = deliveryDetailsRef.current.livingMaterialItems;

                    setLivingMaterialItems(onlyLiving)
                } else if (deliveryDetailsRef.current.specialLivingMaterialItems) {
                    const onlySpecial = deliveryDetailsRef.current.specialLivingMaterialItems;
                    setLivingMaterialItems(onlySpecial)
                }
                else {
                    console.log("livingMaterialItems not updated")
                }
            }
        }

    }, [deliveryDetailsRef.current])

    const populateDataLayer = ()=>{
        if(deliveryDetailsRef.current && deliveryDetailsRef.current.dataLayer){
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(deliveryDetailsRef.current.dataLayer.dataLayerJson);
            const eventData = {"event":"checkoutDelivery"}
            window.dataLayer.push(eventData);
        
    }
    }
    async function handleSubmitContinue(event) {
        event.preventDefault();
        var actionUrl = "api/rest/cb/checkout/continue-billing";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        if (orderSummaryDetailsRef.current) {
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                sessionExpirationURL: "/checkout/login",
                moveToBillingSuccessURL: "/checkout/billing",
                moveToBillingErrorURL: "/checkout/delivery",
                moveToBilling: "Continue"
            }))
            if (res.result == "success") {
                history.push('/checkout/billing','/checkout/delivery')
            }
            else {
                console.log("errorList-----", res)
            }
        } else {
            console.log("Kindly wait still order summary is loading");
        }
    }

    const handleFetchCall = async (selectedMethod) => {
        const actionUrl = "api/rest/cb/checkout/ship-immediate";
        console.log('previousShippingMethodStateRef.current---',previousShippingMethodStateRef.current)
        const Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`;
        if (selectedMethod === 'Standard Ground' || selectedMethod === '2 Day Air' || selectedMethod === 'Overnight') {
            setSelecteCurrentMethod(selectedMethod)
        }
        try {
            const res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                previousShippingMethod: previousShippingMethodStateRef.current === '2 Day Air' ? 'Second Day Air' : previousShippingMethodStateRef.current,
                groupName: "KEY_NON_LIVE_ITEMS",
                modifiedShippingMethod: selecteCurrentMethodRef.current === '2 Day Air' ? 'Second Day Air' : selecteCurrentMethodRef.current,
                moveToBillingSuccessURL: "/checkout/billing",
                moveToBillingErrorURL: "/checkout/delivery",
                shippingMethodCall: "true"
            }));

            if (res.result === "success") {

            } else {
                console.log("Error:", res);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleRepeatCallRestrict = () => {
        if(document.getElementById('checkoutDelivery').classList.contains('pe-auto')){
        document.getElementById('checkoutDelivery').classList.remove('pe-auto')
        }
        if(!document.getElementById('checkoutDelivery').classList.contains('pe-none')){
        document.getElementById('checkoutDelivery').classList.add('pe-none')
        }
    };

    const handleOnchangeMethodLiving = (event) => {

        if (event.currentTarget.value === 'shipSeparately') {
            setShipSeprateFlag(true)
        } else {
            setShipSeprateFlag(false)
        }
        setSelecteLivingMethod(event.currentTarget.value);
    };

    async function handleshipAllTogether( ) {
        var actionUrl = "api/rest/cb/checkout/ship-later";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            groupName: "KEY_LIVING_MATERIAL",
            // currentDate: deliveryDetailsRef.current?.livingMaterialItemShippingMap?.deliveryDate ? deliveryDetailsRef.current.livingMaterialItemShippingMap.deliveryDate :'',
            currentDate: formattedDateForLiving ? formattedDateForLiving :'',
            currentShipMethod: deliveryDetailsRef.current?.livingMaterialItemShippingMap?.shipMethod === '2 Day Air' ? 'Second Day Air' : deliveryDetailsRef.current?.livingMaterialItemShippingMap?.shipMethod ? deliveryDetailsRef.current.livingMaterialItemShippingMap.shipMethod : '',
            changewithBoxSelection: "true"
        }))
        if (res.result == "success") {
        }
        else {
            console.log("errorList-----", res)
        }
        setLivingFlag(false)
        setDetailFlag(true)
    }
    async function handleMethodLiving (method) {
        if (method === 'shipSeparately') {
            setShipSeprateFlag(true)
        } else {
            setShipSeprateFlag(false)
        }
        setSelecteLivingMethod(method);
        if(method === 'shipAllTogether' && livingFlagRef.current === true){
            handleRepeatCallRestrict()
            await handleshipAllTogether();
        }
    };
    // nonLiving ship Group
    const handleOnchangeMethod = (event) => {
        setSelecteNonLivingMethod(event.currentTarget.value);
    };

    const handleOnchangeShipMethod = (event) => {
        setShipGroupFlag(false)
        setSelectedShipGroupMethod(event.currentTarget.value);
    };

    const handleShippingMethod = async (method) => {
        handleRepeatCallRestrict()
        setShipGroupFlag(false)
        setPreviousShippingMethodState(selectedShipGroupMethodRef.current)
        setSelectedShipGroupMethod(method);
        await handleFetchCall(method);
        setDetailFlag(true)
    };

    async function handleShipImmediately(event, shipImmediate) {
        event.preventDefault();
        handleRepeatCallRestrict()
        setSelecteNonLivingMethod(shipImmediate)
        await handleFetchCall(shipImmediate);
        setDetailFlag(true)
    }


    async function handleshipLater(event, shipLater) {
        event.preventDefault();
        setDateTriggered(true)
        setSelecteNonLivingMethod(shipLater);
        var actionUrl = "api/rest/cb/checkout/ship-later";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`

        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            groupName: "KEY_NON_LIVE_ITEMS",
            currentDate: formattedCurrentDateRef.current,
            currentShipMethod: selecteCurrentMethodRef.current === '2 Day Air' ? 'Second Day Air' : selecteCurrentMethodRef.current,
            changewithBoxSelection: "true"
        }))


        if (res.result == "success") {

        }
        else {
            console.log("errorList-----", res)
        }
        setDetailFlag(true)
    }


    // Special
  
    const handleModalOpenSpecial = (item, index) => {
        console.log("item-----special", item)
        var isBackorderId = item?.isBackorderForDropShipItem || 
        item?.isBackorderForGroundOnlyItem || 
        item?.isBackorderForsoftGoodsItem || 
        item?.isBackorderForBackOrderLivingItem || 
        item?.isBackorderForrtsProductsitem || false;
        console.log('isBackorderId------',isBackorderId)
        setIsBackOrderSpecial(isBackorderId)
        setSelectedItemSpecial(item);
        var alternateDates1 = item?.alternateDates1 ? item.alternateDates1 : ''
        setSpecialNotAvailableMethod(alternateDates1)
        var shipMethodLiving = item?.shippingMethodForBackOrderLivingItem ? item.shippingMethodForBackOrderLivingItem : ""
        setShippingSpecialCalendarPrevious(shipMethodLiving)
        setShippingOptionCalendarSpecial(shipMethodLiving)
        setCalendarWithoutGroupName(item.containerGroupNameForlivingMaterialItem)
        const deliveryDate = item?.deliveryDateForBackOrderLivingItem
            ? moment(item.deliveryDateForBackOrderLivingItem)
            :  moment();
            
        const commerceItemId = item?.commerceItemIdForlivingMaterialItem
            ? item.commerceItemIdForlivingMaterialItem
            : '';

        const skuId = item?.skuIdForlivingMaterialItem
            ? item.skuIdForlivingMaterialItem
            : '';

        const quantity = item?.quantityForBackOrderLivingItem
            ? item.quantityForBackOrderLivingItem
            : '';

        const shippingGroupId = item?.shippingGroupIdForBackOrderLivingItem
            ? item.shippingGroupIdForBackOrderLivingItem
            : '';

        setCurrentcommerceItemId(commerceItemId)
        setCurrentSkuId(skuId)
        setCurrentquantity(quantity)
        setSelectedShipGroupId(shippingGroupId)

        const alternateDates1Check = item?.alternateDates1 && typeof item.alternateDates1 === 'string'
            ? item.alternateDates1.split(/\s+/)
            : [];
        console.log('alternateDates1Check---', alternateDates1Check)

        const alternateDates2Check = item?.alternateDates2 && typeof item.alternateDates2 === 'string'
            ? item.alternateDates2.split(/\s+/)
            : [];
        console.log('alternateDates2Check---', alternateDates2Check)

        // Format deliveryDate to "MM/DD/YYYY" to match the dates in alternateDates1 and alternateDates2
        const formattedSelectedDate = deliveryDate.format('MM/DD/YYYY');
        const isDateInAlternateDates1 = alternateDates1Check?.includes(formattedSelectedDate);
        const isDateInAlternateDates2 = alternateDates2Check?.includes(formattedSelectedDate);
        const isSelectedDateInEither = isDateInAlternateDates1 || isDateInAlternateDates2;
        console.log('isSelectedDateInEither---', isSelectedDateInEither)
        if (isSelectedDateInEither) {
            setSelectedDateSpecialItem(deliveryDate.toDate());
        }
        
        setShowDateSpecial(deliveryDate.toDate());
        if (selectedDateSpecialItemRef.current) {
            const formattedDate = deliveryDate.format('MM/DD/YYYY');
            const isAlternateDate = specialNotAvailableMethodRef.current.includes(formattedDate);
            if (!isAlternateDate) {
                setSpecialAlternateDate(formattedDate);
            } else {
                setSpecialAlternateDate('');
            }
        }
        setCurrentDateSpecial(selectedDateSpecialItemRef.current)
        // setUpdateSelectDateSpecial(selectedDateSpecialItemRef.current)
    };

    // living
    const handleModalOpen = (item, index) => {
        console.log("item-----", item)
        if(index === 'livingMap'){
            setCalendarWithoutGroupName('livingMap')
        }else{
            setCalendarWithoutGroupName('')
        }
        setSelectedItem(item);
        var alternateDates1 = item?.alternateDates1 ? item.alternateDates1 : ''
        setLivingNotAvailableMethod(alternateDates1)
        var shipMethodLiving = item?.shipMethod ? item.shipMethod //livingMap
            : item?.shippingMethodForlivingMaterialItem ? item.shippingMethodForlivingMaterialItem
                : item?.shippingMethodForspeciallivingMaterialItem ? item.shippingMethodForspeciallivingMaterialItem : ""
        setShippingOptionCalendarPrevious(shipMethodLiving)
        setShippingOptionCalendar(shipMethodLiving)
        var groupName = item?.containerGroupName ? item.containerGroupName : //livingMap
            item?.containerGroupNameForlivingMaterialItem ? item.containerGroupNameForlivingMaterialItem : ''

        
        const deliveryDate = item?.comDate ? moment(item.comDate) //livingMap
            : item?.deliveryDateForlivingMaterialItem ? moment(item.deliveryDateForlivingMaterialItem)
                : item?.deliveryDateForspeciallivingMaterialItem ? moment(item.deliveryDateForspeciallivingMaterialItem)
                    : moment();
        console.log('deliveryDate----', deliveryDate)
        const commerceItemId =  item?.commerceItemIdForlivingMaterialItem ? item.commerceItemIdForlivingMaterialItem
                : item?.commerceItemIdForspeciallivingMaterialItem ? item.commerceItemIdForspeciallivingMaterialItem : ''

        const skuId = item?.skuIdForlivingMaterialItem ? item.skuIdForlivingMaterialItem //livingMap no need for map and living
            : item?.skuIdForspeciallivingMaterialItem ? item.skuIdForspeciallivingMaterialItem : '';

        const quantity = item?.quantityForlivingMaterialItem ? item.quantityForlivingMaterialItem
                : item?.quantityForspeciallivingMaterialItem ? item.quantityForspeciallivingMaterialItem : 0;

        const shippingGroupId = item?.shippingGroupIdForlivingMaterialItem ? item.shippingGroupIdForlivingMaterialItem
                : item?.shippingGroupIdForspeciallivingMaterialItem ? item.shippingGroupIdForspeciallivingMaterialItem : '';
        setCurrentcommerceItemId(commerceItemId)
        setCurrentSkuId(skuId)
        setCurrentquantity(quantity)
        setSelectedShipGroupId(shippingGroupId)
        setSelectedDate(deliveryDate.toDate());
        setShowDate(deliveryDate.toDate());
        if (selectedDateRef.current) {
            const formattedDate = deliveryDate.format('MM/DD/YYYY');
            const isAlternateDate = livingNotAvailableMethodRef.current?.includes(formattedDate);
            if (!isAlternateDate) {
                setSelectedAlternateDate(formattedDate);
            } else {
                setSelectedAlternateDate('');
            }

        }
        setCurrentDate(selectedDateRef.current)
        // setUpdateSelectDate(selectedDateRef.current)
    };


    const handleModalOpenNonLiving = (nonLivingMapDateRef) => {
        console.log("item-----handleModalOpenNonLiving", nonLivingMapDateRef)
        setSelectedItemNonLiving(nonLivingMapDateRef);
        const deliveryDate = nonLivingMapDateRef && nonLivingMapDateRef.comDate
            ? moment(nonLivingMapDateRef.comDate)
            : "";
        setSelectedDateNonLivingItem(deliveryDate.toDate());
        setShowDateNonLiving(deliveryDate.toDate());
        setCurrentDateNonLiving(selectedDateNonLivingItemRef.current)
    };


    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-container c-delivery-header  `}>
            {/* <div className="c-container c-delivery-header"> */}
            {isLoading && <Loader />}
            <div id="checkoutDelivery" className="row pe-auto justify-content-center c-school-page c-shipping-page c-delivery-page">
                <div className="col-12 col-md-11 my-md-5 my-2">
                    <div className="row">
                        <div id="visibleElement" className="col-12 col-md-8">
                            {deliveryDetailsRef.current?.accountSuccessMsgForb2c ?
                                <div class="d-block alert alert-danger alert-yellow ml-5 mb-3 mr-auto ml-auto">
                                    <p class="black-color">
                                        {deliveryDetailsRef.current && deliveryDetailsRef.current.accountSuccessMsgForb2c}
                                    </p>
                                </div>
                                : ""}
                            {specialProductItemRef.current && specialProductItemRef.current.length > 0 ?
                                <div className="c-delivery-wrapper mb-4">
                                    <p className="text-left mb-1 c-delivery-text c-red-color">Notice: Special Items</p>
                                    <p className="text-left mb-2 c-delivery-text fw-light">
                                        Special Order Items have specific arrival timeframes, and many require several-week lead times for culturing or preparation.
                                    </p>
                                </div>
                                : ""}
                            {specialProductItemRef.current && specialProductItemRef.current.length > 0 ?
                                <div className="row mb-2">
                                    <div className="col-8 col-md-8">
                                    </div>
                                    <div className="col-4 col-md-4">
                                        <p className="text-left mb-2 c-delivery-text">
                                            Est. Arrival Date
                                        </p>
                                    </div>
                                </div>
                                : ""}
                            {specialProductItemRef.current && specialProductItemRef.current.length > 0 ?
                                <div className="mb-10">
                                    {specialProductItemRef.current && specialProductItemRef.current.map((specialproducts) => {
                                        return (
                                            <>
                                                {/* {specialproducts && Object.entries(specialproducts).map(([, specialItemList]) => { */}
                                                {specialproducts && specialproducts.map((specialItemList, index) => {
                                                    var dateObjectStartDate = new Date(specialItemList?.arrivalStartDateForDropShipItem ? specialItemList.arrivalStartDateForDropShipItem :
                                                        specialItemList?.arrivalStartDateForGroundOnlyItem ? specialItemList.arrivalStartDateForGroundOnlyItem :
                                                            specialItemList?.arrivalStartDateForsoftGoodsItem ? specialItemList.arrivalStartDateForsoftGoodsItem :
                                                                specialItemList?.arrivalStartDateForBackOrderLivingItem ? specialItemList.arrivalStartDateForBackOrderLivingItem :
                                                                    specialItemList?.arrivalStartDateForrtsProductsitem ? specialItemList.arrivalStartDateForrtsProductsitem :
                                                                        "");

                                                    var dateObjectEndDate = new Date(specialItemList?.arrivalEndDateForDropShipItem ? specialItemList.arrivalEndDateForDropShipItem :
                                                        specialItemList?.arrivalEndDateForGroundOnlyItem ? specialItemList.arrivalEndDateForGroundOnlyItem :
                                                            specialItemList?.arrivalEndDateForsoftGoodsItem ? specialItemList.arrivalEndDateForsoftGoodsItem :
                                                                specialItemList?.arrivalEndDateForBackOrderLivingItem ? specialItemList.arrivalEndDateForBackOrderLivingItem :
                                                                    specialItemList?.arrivalEndDateForrtsProductsitem ? specialItemList.arrivalEndDateForrtsProductsitem :
                                                                        "")
                                                    // Get the start or arrival date of the item
                                                    var startDay = dateObjectStartDate.getDate();
                                                    var startMonth = dateObjectStartDate.getMonth() + 1;
                                                    var startYear = dateObjectStartDate.getFullYear();
                                                    startDay = startDay < 10 ? '0' + startDay : startDay;
                                                    startMonth = startMonth < 10 ? '0' + startMonth : startMonth;
                                                    var formattedStartDate = startMonth + '/' + startDay + '/' + startYear;

                                                    // Get the end date of the item
                                                    var endDay = dateObjectEndDate.getDate();
                                                    var endMonth = dateObjectEndDate.getMonth() + 1;
                                                    var endYear = dateObjectEndDate.getFullYear();
                                                    endDay = endDay < 10 ? '0' + endDay : endDay;
                                                    endMonth = endMonth < 10 ? '0' + endMonth : endMonth;
                                                    var formattedEndDate = endMonth + '/' + endDay + '/' + endYear;
                                                    return (
                                                        <>
                                                            <div className="row mb-3">
                                                                <div className="col-8 col-md-8">
                                                                    <div className="c-delivery-item">
                                                                        <span className="c-delivery-img">
                                                                            <img onError={replaceImage} src={`${specialItemList?.imagePathForDropShipItem ? specialItemList.imagePathForDropShipItem :
                                                                                specialItemList?.imagePathForGroundOnlyItem ? specialItemList.imagePathForGroundOnlyItem :
                                                                                    specialItemList?.imagePathForsoftGoodsItem ? specialItemList.imagePathForsoftGoodsItem :
                                                                                        specialItemList?.imagePathForBackOrderLivingItem ? specialItemList.imagePathForBackOrderLivingItem :
                                                                                            specialItemList?.imagePathForrtsProductsitem ? specialItemList.imagePathForrtsProductsitem :
                                                                                                ""}`} />
                                                                        </span>
                                                                        <div className="c-delivery-items">
                                                                            <p className="c-delivery-item-text">
                                                                                {specialItemList?.arrivalMsgForDropShipItem ? specialItemList.arrivalMsgForDropShipItem :
                                                                                    specialItemList?.arrivalMsgForGroundOnlyLivingItem ? specialItemList.arrivalMsgForGroundOnlyLivingItem :
                                                                                        specialItemList?.arrivalMsgForSoftGoodLivingItem ? specialItemList.arrivalMsgForSoftGoodLivingItem :
                                                                                            specialItemList?.arrivalMsgForBackOrderLivingItem ? specialItemList.arrivalMsgForBackOrderLivingItem :
                                                                                                specialItemList?.arrivalMsgForRtsProductLivingItem ? specialItemList.arrivalMsgForRtsProductLivingItem : ""}
                                                                            </p>
                                                                            <p className="c-delivery-item-text fw-light">{`#${specialItemList?.itemNumberForDropShipItem ? specialItemList.itemNumberForDropShipItem :
                                                                                specialItemList?.itemNumberForGroundOnlyItem ? specialItemList.itemNumberForGroundOnlyItem :
                                                                                    specialItemList?.itemNumberForsoftGoodsItem ? specialItemList.itemNumberForsoftGoodsItem :
                                                                                        specialItemList?.itemNumberForBackOrderLivingItem ? specialItemList.itemNumberForBackOrderLivingItem :
                                                                                            specialItemList?.itemNumberForrtsProductsitem ? specialItemList.itemNumberForrtsProductsitem : ""}
                                                                                 Qty:${specialItemList?.quantityForDropShipItem ? specialItemList.quantityForDropShipItem :
                                                                                    specialItemList?.quantityForGroundOnlyItem ? specialItemList.quantityForGroundOnlyItem :
                                                                                        specialItemList?.quantityForsoftGoodsItem ? specialItemList.quantityForsoftGoodsItem :
                                                                                            specialItemList?.quantityForBackOrderLivingItem ? specialItemList.quantityForBackOrderLivingItem :
                                                                                                specialItemList?.quantityForrtsProductsitem ? specialItemList.quantityForrtsProductsitem : ""}
                                                                                `}</p>
                                                                            <p className="c-delivery-item-text fw-light"
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: specialItemList?.productDescForDropShipItem ? specialItemList.productDescForDropShipItem :
                                                                                        specialItemList?.productDescForGroundOnlyItem ? specialItemList.productDescForGroundOnlyItem :
                                                                                            specialItemList?.productDescForsoftGoodsItem ? specialItemList.productDescForsoftGoodsItem :
                                                                                                specialItemList?.productDescForBackOrderLivingItem ? specialItemList.productDescForBackOrderLivingItem :
                                                                                                    specialItemList?.productDescForrtsProductsitem ? specialItemList.productDescForrtsProductsitem : ""
                                                                                }}>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-4 col-md-4 align-self-center">
                                                                    {specialItemList?.itemNumberForDropShipItem || specialItemList?.itemNumberForGroundOnlyItem || specialItemList?.itemNumberForrtsProductsitem ?
                                                                        <p className="text-left mb-0 c-delivery-content">{formattedStartDate} - {formattedEndDate}</p>
                                                                        : specialItemList && specialItemList.itemNumberForsoftGoodsItem ?
                                                                            <p className="text-left mb-0 c-delivery-content">Electronic Delivery</p>
                                                                            : specialItemList && specialItemList.itemNumberForBackOrderLivingItem ?
                                                                                <div className="row">
                                                                                    <div className="col-12 col-md-6">
                                                                                        <p className="text-left mb-0 c-delivery-content">
                                                                                            {formattedStartDate}
                                                                                        </p>
                                                                                        <p className="text-left mb-0 c-delivery-content">
                                                                                            {/* special item shipMethod show only for backOrderItem*/}
                                                                                            {specialItemList?.shippingMethodForBackOrderLivingItem ? specialItemList.shippingMethodForBackOrderLivingItem
                                                                                                : ''}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <button data-bs-toggle="modal" data-bs-target={`#specialItem-calendar${index}`} onClick={() => handleModalOpenSpecial(specialItemList, index)} className="btn btn-outline-secondary c-shipping-change-btn modal-link">edit</button>
                                                                                    </div>
                                                                                </div>
                                                                                : ""}
                                                                </div>
                                                            </div>
                                                            <SpecialCalendarModal
                                                             index={index}
                                                             selectedItemSpecial={selectedItemSpecialRef.current}
                                                             showDateSpecial={showDateSpecialRef.current} setShowDateSpecial={setShowDateSpecial}
                                                             selectedDateSpecialItem={selectedDateSpecialItemRef.current} setSelectedDateSpecialItem={setSelectedDateSpecialItem}
                                                             specialAlternateDate={specialAlternateDateRef.current} setSpecialAlternateDate={setSpecialAlternateDate}
                                                             shippingOptionCalendarSpecial={shippingOptionCalendarSpecialRef.current} setShippingOptionCalendarSpecial={setShippingOptionCalendarSpecial}
                                                             specialNotAvailableMethod={specialNotAvailableMethodRef.current}
                                                             setDetailFlag={setDetailFlag}
                                                             shippingSpecialCalendarPrevious={shippingSpecialCalendarPrevious}
                                                             currentDateSpecial={currentDateSpecial}
                                                             currentcommerceItemId={currentcommerceItemId}
                                                             currentSkuId={currentSkuId}
                                                             currentquantity={currentquantity}
                                                             selectedShipGroupId={selectedShipGroupId}
                                                             backOrdered={isBackOrderSpecialRef.current}
                                                            />

                                                        </>
                                                    )
                                                })}
                                            </>
                                        )
                                    })}


                                </div>
                                : ""}


                            {livingProductItemRef.current && livingProductItemRef.current.length > 0 ?
                                <div className="row">
                                    <div className="col-12 col-md-12 text-left mb-3">
                                        <h1 className="c-account-heading fw-bold">Your Perishable / Living Items</h1>
                                    </div>
                                </div>
                                : ""}

                            {/* {livingCardRef.current ? */}
                            {deliveryDetailsRef.current && deliveryDetailsRef.current.livingMaterialItemShippingMap ?
                                <form class="row g-4 mb-5">

                                    <div class="col-12 col-md-12 text-left mb-3">
                                        <h1 class="c-account-heading fw-normal">Select your shipping preference:</h1>
                                    </div>
                                    <label class="col-12 col-md-6" htmlFor="ship-all-together"
                                        onClick={() => selecteLivingMethodRef.current !== 'shipAllTogether' && handleMethodLiving("shipAllTogether")}
                                    >
                                        <div class={`c-box-shipping ${selecteLivingMethodRef.current === 'shipAllTogether' && 'active'}`}>
                                            <div class="form-check">
                                                <input class="form-check-input"
                                                    type="radio"
                                                    name="delivery-live-toggle"
                                                    id="ship-all-together"
                                                    value="shipAllTogether"
                                                    checked={selecteLivingMethodRef.current === 'shipAllTogether'}
                                                    defaultChecked={selecteLivingMethodRef.current === 'shipAllTogether'}
                                                    onChange={handleOnchangeMethodLiving}
                                                />
                                                <div class="form-check-label">
                                                    Ship All Together
                                                </div>
                                            </div>
                                            <div class="c-box-calendar-info fst-italic">
                                                <p>I want everything the same day</p>
                                            </div>
                                            <div class="c-box-shipping-calendar">
                                                <p class="c-box-calendar-icon me-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100" className="calendar-svg">
                                                        <g>
                                                            <g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 28" x="0px" y="0px">
                                                                <title>calendar</title>
                                                                <path d="M2 26h4.5v-4.5h-4.5v4.5zM7.5 26h5v-4.5h-5v4.5zM2 20.5h4.5v-5h-4.5v5zM7.5 20.5h5v-5h-5v5zM2 14.5h4.5v-4.5h-4.5v4.5zM13.5 26h5v-4.5h-5v4.5zM7.5 14.5h5v-4.5h-5v4.5zM19.5 26h4.5v-4.5h-4.5v4.5zM13.5 20.5h5v-5h-5v5zM8 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM19.5 20.5h4.5v-5h-4.5v5zM13.5 14.5h5v-4.5h-5v4.5zM19.5 14.5h4.5v-4.5h-4.5v4.5zM20 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM26 6v20c0 1.094-0.906 2-2 2h-22c-1.094 0-2-0.906-2-2v-20c0-1.094 0.906-2 2-2h2v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h6v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h2c1.094 0 2 0.906 2 2z">
                                                                </path>
                                                            </svg></g>
                                                        </g>
                                                    </svg>
                                                </p>
                                                {selecteLivingMethodRef.current === 'shipAllTogether' ?
                                                    <div class="shipTogetherActive c-box-calendar-info c-box-calendar-active-info">

                                                        <p>{deliveryDetailsRef.current?.livingMaterialItemShippingMap && deliveryDetailsRef.current?.livingMaterialItemShippingMap?.comDay}, {formattedDateForLiving}</p>
                                                        <p>
                                                            Shipping:&nbsp;
                                                            {deliveryDetailsRef.current?.livingMaterialItemShippingMap && deliveryDetailsRef.current?.livingMaterialItemShippingMap?.shipMethod}
                                                        </p>
                                                    </div> : ""}

                                                <div class="shipTogetherActive" >
                                                    {selecteLivingMethodRef.current === 'shipAllTogether' ?
                                                        <div className="btn btn-outline-secondary c-shipping-change-btn" onClick={() => handleModalOpen(livingMapDateRef.current, 'livingMap')} id="select-arrival-button" href="#livingOrSpecial-calendar0" data-bs-toggle="modal">edit</div>
                                                        : <div class="btn btn-outline-secondary c-shipping-change-btn">Select Arrival Date</div>}
                                                </div>
                                            </div>
                                            <div class="container-circle">
                                                <div class="circle">
                                                </div>
                                            </div>
                                        </div>
                                    </label>



                                    <label class="col-12 col-md-6" htmlFor="ship-separately"
                                        onClick={() => selecteLivingMethodRef.current !== 'shipSeparately' && handleMethodLiving("shipSeparately")}
                                    >
                                        <div class={`c-box-shipping ${selecteLivingMethodRef.current === 'shipSeparately' && 'active'}`}>
                                            <div class="form-check">
                                                <input class="form-check-input"
                                                    type="radio"
                                                    name="delivery-live-toggle"
                                                    id="ship-separately"
                                                    value="shipSeparately"
                                                    checked={selecteLivingMethodRef.current === 'shipSeparately'}
                                                    defaultChecked={selecteLivingMethodRef.current === 'shipSeparately'}
                                                    onChange={handleOnchangeMethodLiving}
                                                />
                                                <div class="form-check-label">
                                                    Ship Separately
                                                </div>
                                            </div>

                                            <div class="c-box-shipping-calendar">
                                                <div class="c-box-calendar-info fst-italic">
                                                    <p>I want items on different days</p>
                                                </div>
                                            </div>
                                            <div class="container-circle">
                                                <div class="circle">
                                                </div>
                                            </div>
                                        </div>
                                    </label>

                                </form>
                                : ""}

                            {livingProductItemRef.current && livingProductItemRef.current.length > 0 ?
                                <div className="row mb-2">
                                    <div className="col-8 col-md-8">
                                    </div>
                                    <div className="col-4 col-md-4">
                                        <p className="text-left mb-2 c-delivery-text">Arrival Date</p>
                                    </div>
                                </div>
                                : ""}
                            {livingProductItemRef.current && livingProductItemRef.current.length > 0 ?
                                <div className="mb-10">
                                    {livingProductItemRef.current && livingProductItemRef.current.map((livingproducts, index) => {
                                        return (
                                            <>
                                                {livingproducts && livingproducts.map((livingItemList, index) => {
                                                    var dateObject = new Date(livingItemList?.arrivalStartDateForlivingMaterialItem ? livingItemList.arrivalStartDateForlivingMaterialItem :
                                                        livingItemList?.arrivalStartDateForspeciallivingMaterialItem ? livingItemList.arrivalStartDateForspeciallivingMaterialItem :
                                                            "");
                                                    var day = dateObject.getDate();
                                                    var month = dateObject.getMonth() + 1;
                                                    var year = dateObject.getFullYear();
                                                    day = day < 10 ? '0' + day : day;
                                                    month = month < 10 ? '0' + month : month;
                                                    var formattedDate = month + '/' + day + '/' + year;
                                                    return (
                                                        <>
                                                            <div className="row mb-3">
                                                                <div className="col-8 col-md-8">
                                                                    <div className="c-delivery-item">
                                                                        <span className="c-delivery-img">
                                                                            <img onError={replaceImage} src={`${livingItemList?.imagePathForlivingMaterialItem ? livingItemList.imagePathForlivingMaterialItem :
                                                                                livingItemList?.imagePathForspeciallivingMaterialItem ? livingItemList.imagePathForspeciallivingMaterialItem :
                                                                                    ""}`} />
                                                                        </span>
                                                                        <div className="c-delivery-items c-delivery-items-weight">
                                                                            <p className="c-delivery-item-text fw-light">#{livingItemList?.itemNumberForlivingMaterialItem ? livingItemList.itemNumberForlivingMaterialItem :
                                                                                livingItemList?.itemNumberForspeciallivingMaterialItem ? livingItemList.itemNumberForspeciallivingMaterialItem
                                                                                    : ""}  Qty:{livingItemList?.quantityForlivingMaterialItem ? livingItemList.quantityForlivingMaterialItem :
                                                                                        livingItemList?.quantityForspeciallivingMaterialItem ? livingItemList.quantityForspeciallivingMaterialItem :
                                                                                            ""}</p>
                                                                            <p className="c-delivery-item-text fw-light"
                                                                            dangerouslySetInnerHTML={{ __html: livingItemList?.productDescForlivingMaterialItem ? livingItemList.productDescForlivingMaterialItem :
                                                                                livingItemList?.productDescForspeciallivingMaterialItem ? livingItemList.productDescForspeciallivingMaterialItem :
                                                                                    ""}}>
                                                                                </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-4 col-md-4 align-self-center">
                                                                    <div className="row">
                                                                        <div className="col-12 col-md-6">
                                                                            <p className="text-left mb-0 c-delivery-content">
                                                                                {formattedDate}
                                                                            </p>
                                                                            {shipSeprateFlag ?
                                                                                <p className="text-left mb-0 c-delivery-content livShipMethod">
                                                                                    {livingItemList?.shippingMethodForlivingMaterialItem ? livingItemList.shippingMethodForlivingMaterialItem :
                                                                                        livingItemList?.shippingMethodForspeciallivingMaterialItem ? livingItemList.shippingMethodForspeciallivingMaterialItem :
                                                                                            ""}
                                                                                </p>
                                                                                : ""}
                                                                        </div>
                                                                        {shipSeprateFlag ?
                                                                            <div className="col-12 col-md-6 livSingleDateEdit">
                                                                                <button data-bs-toggle="modal" data-bs-target={`#livingOrSpecial-calendar${index}`} index={index} onClick={() => handleModalOpen(livingItemList, index)} className="btn btn-outline-secondary c-shipping-change-btn modal-link">edit</button>
                                                                            </div>
                                                                            : ""}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                                <LivingCalendarModal
                                                                    index={index}
                                                                    shipSeprateFlag={shipSeprateFlag}
                                                                    selectedItem={selectedItemRef.current}
                                                                    showDate={showDateRef.current} setShowDate={setShowDate}
                                                                    selectedDate={selectedDateRef.current} setSelectedDate={setSelectedDate}
                                                                    selectedAlternateDate={selectedAlternateDateRef.current} setSelectedAlternateDate={setSelectedAlternateDate}
                                                                    shippingOptionCalendar={shippingOptionCalendarRef.current} setShippingOptionCalendar={setShippingOptionCalendar}
                                                                    livingNotAvailableMethod={livingNotAvailableMethodRef.current}
                                                                    setDetailFlag={setDetailFlag}
                                                                    shippingOptionCalendarPrevious={shippingOptionCalendarPrevious}
                                                                    currentDate={currentDate}
                                                                    currentcommerceItemId={currentcommerceItemId}
                                                                    currentSkuId={currentSkuId}
                                                                    currentquantity={currentquantity}
                                                                    selectedShipGroupId={selectedShipGroupId}
                                                                    setLivingFlag={setLivingFlag}
                                                                    calendarWithoutGroupName={calendarWithoutGroupNameRef.current}
                                                                />
                                                           
                                                        </>
                                                    )
                                                })}
                                            </>
                                        )
                                    })}

                                </div>
                                : ""}
                            {deliveryDetailsRef.current && deliveryDetailsRef.current.nonLivingMaterialItemShippingMap ?
                                <div className="row">
                                    <div className="col-12 col-md-12 text-left mb-3 ">
                                        <h1 className="c-account-heading fw-bold">
                                            Your In-Stock, Non-Perishable Items
                                        </h1>
                                    </div>
                                </div> : ""}
                            {deliveryDetailsRef.current && deliveryDetailsRef.current.nonLivingMaterialItemShippingMap ?
                                <div className="row mt-3">
                                    <div className="col-12 col-md-12 text-left mb-3">
                                        <h1 className="c-account-heading fw-normal">Select your shipping preference:</h1>
                                    </div>
                                </div> : ""}
                            {deliveryDetailsRef.current && deliveryDetailsRef.current.nonLivingMaterialItemShippingMap ?
                                <form className="row g-4">

                                    <label className='col-12 col-md-6' htmlFor="ship-immediately" onClick={(event) => selecteNonLivingMethodRef.current !== 'shipImmediate' && handleShipImmediately(event, "shipImmediate")}>
                                        <div className={`c-box-shipping ${selecteNonLivingMethodRef.current === 'shipImmediate' && 'active'}`} id="ship-Immediate">
                                            <div className="form-check">
                                                <input className="form-check-input"
                                                    type="radio"
                                                    id='ship-immediately'
                                                    name="shippingPrefernce"
                                                    value="shipImmediate"
                                                    checked={selecteNonLivingMethodRef.current === 'shipImmediate'}
                                                    defaultChecked={selecteNonLivingMethodRef.current === 'shipImmediate'}
                                                    onChange={handleOnchangeMethod}

                                                />

                                                <div className="form-check-label fw-bold">
                                                    Ship Immediately
                                                </div>
                                            </div>
                                            <div className="c-box-shipping-calendar">
                                                <p className="c-box-calendar-icon me-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100" className="calendar-svg">
                                                        <g>
                                                            <g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 28" x="0px" y="0px">
                                                                <title>calendar</title>
                                                                <path d="M2 26h4.5v-4.5h-4.5v4.5zM7.5 26h5v-4.5h-5v4.5zM2 20.5h4.5v-5h-4.5v5zM7.5 20.5h5v-5h-5v5zM2 14.5h4.5v-4.5h-4.5v4.5zM13.5 26h5v-4.5h-5v4.5zM7.5 14.5h5v-4.5h-5v4.5zM19.5 26h4.5v-4.5h-4.5v4.5zM13.5 20.5h5v-5h-5v5zM8 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM19.5 20.5h4.5v-5h-4.5v5zM13.5 14.5h5v-4.5h-5v4.5zM19.5 14.5h4.5v-4.5h-4.5v4.5zM20 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM26 6v20c0 1.094-0.906 2-2 2h-22c-1.094 0-2-0.906-2-2v-20c0-1.094 0.906-2 2-2h2v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h6v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h2c1.094 0 2 0.906 2 2z">
                                                                </path>
                                                            </svg></g>
                                                        </g>





                                                    </svg>
                                                </p>
                                                <div className="c-box-calendar-info">
                                                    <p>Leaves our facility</p><p>in 1-3 days</p>
                                                </div>
                                            </div>
                                            <div className="container-circle">
                                                <div className="circle">
                                                </div>
                                            </div>
                                        </div>
                                    </label>

                                    <label className='col-12 col-md-6' htmlFor='ship-at-later-time' onClick={(event) => selecteNonLivingMethodRef.current !== 'shipLater' && handleshipLater(event, "shipLater")}>
                                        <div className={`c-box-shipping ${selecteNonLivingMethodRef.current === 'shipLater' && 'active'}`} id="ship-Later">
                                            <div className="form-check">
                                                <input className="form-check-input"
                                                    type="radio"
                                                    id='ship-at-later-time'
                                                    name="shippingPrefernce"
                                                    value="shipLater"
                                                    checked={selecteNonLivingMethodRef.current === 'shipLater'}
                                                    defaultChecked={selecteNonLivingMethodRef.current === 'shipLater'}
                                                    onChange={handleOnchangeMethod}
                                                />

                                                <div className="form-check-label fw-bold" >
                                                    Ship at a Later Time
                                                </div>
                                            </div>
                                            <div className="c-box-shipping-calendar">
                                                <p className="c-box-calendar-icon me-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100" className="calendar-svg">
                                                        <g>
                                                            <g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 28" x="0px" y="0px">
                                                                <title>calendar</title>
                                                                <path d="M2 26h4.5v-4.5h-4.5v4.5zM7.5 26h5v-4.5h-5v4.5zM2 20.5h4.5v-5h-4.5v5zM7.5 20.5h5v-5h-5v5zM2 14.5h4.5v-4.5h-4.5v4.5zM13.5 26h5v-4.5h-5v4.5zM7.5 14.5h5v-4.5h-5v4.5zM19.5 26h4.5v-4.5h-4.5v4.5zM13.5 20.5h5v-5h-5v5zM8 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM19.5 20.5h4.5v-5h-4.5v5zM13.5 14.5h5v-4.5h-5v4.5zM19.5 14.5h4.5v-4.5h-4.5v4.5zM20 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM26 6v20c0 1.094-0.906 2-2 2h-22c-1.094 0-2-0.906-2-2v-20c0-1.094 0.906-2 2-2h2v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h6v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h2c1.094 0 2 0.906 2 2z">
                                                                </path>
                                                            </svg></g>
                                                        </g>
                                                    </svg>
                                                </p>
                                                {selecteNonLivingMethodRef.current !== 'shipLater' ?
                                                    <div class="btn btn-outline-secondary c-shipping-change-btn">Select Arrival Date</div>
                                                    : ""}
                                                {selecteNonLivingMethodRef.current === 'shipLater' ?
                                                    <div class="c-box-calendar-info c-box-calendar-active-info">
                                                        <p>{deliveryDetailsRef.current?.nonLivingMaterialItemShippingMap && deliveryDetailsRef.current?.nonLivingMaterialItemShippingMap?.comDay}, {formattedDateForNonLiving}</p>
                                                        <p>
                                                            Shipping:
                                                            Ground
                                                        </p>
                                                    </div>
                                                    : ""}
                                                {selecteNonLivingMethodRef.current === 'shipLater' ?
                                                    <div className="btn btn-outline-secondary c-shipping-change-btn" onClick={() => handleModalOpenNonLiving(nonLivingMapDateRef.current)} id="select-arrival-button" href="#nonLiving-calendar-modal" data-bs-toggle="modal">edit</div>
                                                    : ""}
                                            </div>
                                            <div className="container-circle">
                                                <div className="circle">
                                                </div>
                                            </div>
                                        </div>
                                    </label>

                                    <NonLivingCalendarModal 
                                      selectedItemNonLiving={selectedItemNonLivingRef.current}
                                      showDateNonLiving={showDateNonLivingRef.current} setShowDateNonLiving={setShowDateNonLiving}
                                      selectedDateNonLivingItem={selectedDateNonLivingItemRef.current} setSelectedDateNonLivingItem={setSelectedDateNonLivingItem}
                                      currentDateNonLiving={currentDateNonLiving}
                                      setDetailFlag={setDetailFlag}
                                    />
                                </form>

                                : ""}

                            {selecteNonLivingMethod === 'shipImmediate' ?
                                <div id="shippingMethods" className="c-shipping-box-small">
                                    <div className="row mt-5">
                                        <div className="col-12 col-md-12 text-left mb-3">
                                            <h1 className="c-account-heading fw-normal">Select shipping method:</h1>
                                        </div>
                                    </div>
                                    <form className="row">
                                        <label className="col-12 col-md-4" htmlFor='standard-ground' onClick={() => selectedShipGroupMethodRef.current !== 'Standard Ground' && handleShippingMethod('Standard Ground')}>
                                            <div className={`c-box-shipping ${selectedShipGroupMethodRef.current === 'Standard Ground' ? 'active' : ''}`} id="standard-ground-div">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        name="modifiedShippingMethod"
                                                        id="standard-ground"
                                                        type="radio"
                                                        value="Standard Ground"
                                                        checked={selectedShipGroupMethodRef.current === 'Standard Ground'}
                                                        defaultChecked={selectedShipGroupMethodRef.current === 'Standard Ground'}
                                                        onChange={handleOnchangeShipMethod} />
                                                </div>
                                                <div className="c-box-shipping-calendar">
                                                    <p className="c-box-calendar-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100" className="calendar-svg">
                                                            <g>
                                                                <g transform="translate(50 50) scale(0.8 0.8) rotate(0) translate(-50 -50)">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333 333" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd">
                                                                        <g>
                                                                            <path d="M101 232c0,-18 -22,-21 -28,-7 -4,8 1,18 10,20 9,2 18,-6 18,-13zm143 -16c-18,0 -21,22 -7,28 6,3 13,1 16,-3 10,-10 1,-25 -9,-25zm-104 -65l0 -26c0,-1 0,-2 -2,-2 -27,0 -22,-2 -28,7 -4,5 -7,10 -11,16 -2,3 -6,7 -2,7l41 0c2,0 2,0 2,-2zm159 -56l0 135c0,12 -19,9 -27,9 -3,14 -17,23 -30,22 -22,-1 -28,-22 -30,-22l-95 0c-4,0 -6,21 -30,22 -13,1 -27,-9 -30,-22 -4,0 -13,1 -17,0 -3,-1 -8,-5 -8,-9l0 -17c0,-6 5,-10 10,-11 0,-10 -2,-30 3,-39 7,-12 26,-8 30,-12 1,0 4,-5 5,-6 8,-13 20,-37 36,-37l43 0c0,-10 -2,-24 12,-24l115 0c7,0 13,4 13,11z">
                                                                            </path>
                                                                        </g>
                                                                    </svg>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </p>

                                                    <div className="c-box-calendar-info m-0">
                                                        <p className="fw-bold">Standard Ground</p>
                                                        <p> 3-5 days
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </label>

                                        <label className="col-12 col-md-4" htmlFor='second-day-air' onClick={() => selectedShipGroupMethodRef.current !== '2 Day Air' && handleShippingMethod('2 Day Air')}>
                                            <div className={`c-box-shipping ${selectedShipGroupMethodRef.current === '2 Day Air' ? 'active' : ''}`} id="second-day-air-div" >
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        name="modifiedShippingMethod"
                                                        id="second-day-air"
                                                        type="radio"
                                                        value="2 Day Air"
                                                        checked={selectedShipGroupMethodRef.current === '2 Day Air'}
                                                        defaultChecked={selectedShipGroupMethodRef.current === '2 Day Air'}
                                                        onChange={handleOnchangeShipMethod}
                                                    />
                                                </div>
                                                <div className="c-box-shipping-calendar">
                                                    <p className="c-box-calendar-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100">
                                                            <g><g transform="translate(50 50) scale(0.5 0.5) rotate(0) translate(-50 -50)">
                                                                <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="370.9 247.6 100 100" enable-background="new 370.9 247.6 100 100">
                                                                    <g><path d="M469.8,269.8l-9-6.5c-0.5-0.3-1-0.5-1.9-0.5l-53,4.4c-5-5-19.4-18.7-28.1-18.7c-2,0-3.7,0.7-5,1.9    c-1.3,1.3-1.9,3.1-1.9,5.1c0.1,8.5,13.7,22.6,18.6,27.4l-4.3,53.6c0,0.6,0.1,1.2,0.4,1.7l4.5,7.3c0.5,0.8,1.4,1.3,2.4,1.3    c0.1,0,0.3,0,0.4,0c1.1-0.1,2-0.9,2.3-1.9l13.4-43.9l25.5,20.1l0.3,18c0,0.6,0.2,1.2,0.6,1.7l2.7,3.2c0.5,0.6,1.2,0.9,2.3,1    c0.9-0.1,1.7-0.5,2.2-1.3l9.3-14.9l14.4-9c0.8-0.5,1.2-1.3,1.3-2.2c0.1-0.9-0.3-1.8-1-2.3l-3.1-2.7c-0.5-0.4-1-0.6-1.6-0.7    l-17.3-1.1l-20.7-24.6l45.3-11.5c1-0.3,1.8-1.1,2.1-2.2C471.1,271.6,470.6,270.5,469.8,269.8z">
                                                                    </path></g>
                                                                </svg></g></g>
                                                        </svg>
                                                    </p>

                                                    <div className="c-box-calendar-info m-0">
                                                        <p className="fw-bold">2 Day Air </p>
                                                        <p> 2 day</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>

                                        <label className="col-12 col-md-4" htmlFor='overnight' onClick={() => selectedShipGroupMethodRef.current !== 'Overnight' && handleShippingMethod('Overnight')}>
                                            <div className={`c-box-shipping ${selectedShipGroupMethodRef.current === 'Overnight' ? 'active' : ''}`} id="overnight-div" >
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        name="modifiedShippingMethod"
                                                        id="overnight"
                                                        type="radio"
                                                        value="Overnight"
                                                        checked={selectedShipGroupMethodRef.current === 'Overnight'}
                                                        defaultChecked={selectedShipGroupMethodRef.current === 'Overnight'}
                                                        onChange={handleOnchangeShipMethod}
                                                    />
                                                </div>
                                                <div className="c-box-shipping-calendar">
                                                    <p className="c-box-calendar-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100">
                                                            <g>
                                                                <g transform="translate(50 50) scale(0.5 0.5) rotate(0) translate(-50 -50)" >
                                                                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="370.9 247.6 100 100" enable-background="new 370.9 247.6 100 100" >
                                                                        <g><path d="M469.8,269.8l-9-6.5c-0.5-0.3-1-0.5-1.9-0.5l-53,4.4c-5-5-19.4-18.7-28.1-18.7c-2,0-3.7,0.7-5,1.9    c-1.3,1.3-1.9,3.1-1.9,5.1c0.1,8.5,13.7,22.6,18.6,27.4l-4.3,53.6c0,0.6,0.1,1.2,0.4,1.7l4.5,7.3c0.5,0.8,1.4,1.3,2.4,1.3    c0.1,0,0.3,0,0.4,0c1.1-0.1,2-0.9,2.3-1.9l13.4-43.9l25.5,20.1l0.3,18c0,0.6,0.2,1.2,0.6,1.7l2.7,3.2c0.5,0.6,1.2,0.9,2.3,1    c0.9-0.1,1.7-0.5,2.2-1.3l9.3-14.9l14.4-9c0.8-0.5,1.2-1.3,1.3-2.2c0.1-0.9-0.3-1.8-1-2.3l-3.1-2.7c-0.5-0.4-1-0.6-1.6-0.7    l-17.3-1.1l-20.7-24.6l45.3-11.5c1-0.3,1.8-1.1,2.1-2.2C471.1,271.6,470.6,270.5,469.8,269.8z">
                                                                        </path></g>
                                                                    </svg></g>
                                                            </g>
                                                        </svg>
                                                    </p>

                                                    <div className="c-box-calendar-info m-0">
                                                        <p className="fw-bold">Overnight</p>
                                                        <p>next day </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    </form>
                                </div>
                                : ""}
                            {nonLivingProductItemRef.current.length > 0 ?
                                <div className="row mt-5">
                                    <div className="col-8 col-md-8"></div>
                                    <div className="col-4 col-md-4">
                                        <p className="text-left mb-2 c-delivery-text">Arrival Date</p>
                                    </div>
                                </div>
                                : ""}
                            <div className="mb-10">
                                {nonLivingProductItemRef.current && nonLivingProductItemRef.current.map((nonLivingProducts) => {
                                    return (
                                        <>
                                            {nonLivingProducts && Object.entries(nonLivingProducts).map(([, nonLivingItemList]) => {

                                                var dateObjectStartDate = new Date(nonLivingItemList && nonLivingItemList.arrivalStartDateFornonLiveMaterialitem ? nonLivingItemList.arrivalStartDateFornonLiveMaterialitem :
                                                    "");
                                                var dateObjectEndDate = new Date(nonLivingItemList && nonLivingItemList.arrivalEndDateFornonLiveMaterialitem ? nonLivingItemList.arrivalEndDateFornonLiveMaterialitem :
                                                    "");
                                                // Get the start or arrival date of the item
                                                var startDay = dateObjectStartDate.getDate();
                                                var startMonth = dateObjectStartDate.getMonth() + 1;
                                                var startYear = dateObjectStartDate.getFullYear();
                                                startDay = startDay < 10 ? '0' + startDay : startDay;
                                                startMonth = startMonth < 10 ? '0' + startMonth : startMonth;
                                                var formattedStartDate = startMonth + '/' + startDay + '/' + startYear;

                                                // Get the end of the item
                                                var endDay = dateObjectEndDate.getDate();
                                                var endMonth = dateObjectEndDate.getMonth() + 1;
                                                var endYear = dateObjectEndDate.getFullYear();
                                                endDay = endDay < 10 ? '0' + endDay : endDay;
                                                endMonth = endMonth < 10 ? '0' + endMonth : endMonth;
                                                var formattedEndDate = endMonth + '/' + endDay + '/' + endYear;
                                                return (
                                                    <>
                                                        <div className="row mb-3">
                                                            <div className="col-8 col-md-8">
                                                                <div className="c-delivery-item">
                                                                    <span className="c-delivery-img">
                                                                        <img onError={replaceImage} src={`${nonLivingItemList.imagePathFornonLiveMaterialitem}`} />
                                                                    </span>
                                                                    <div className="c-delivery-items c-delivery-items-weight">
                                                                        <p className="c-delivery-item-text fw-light">#{nonLivingItemList.itemNumberFornonLiveMaterialitem}  Qty:{nonLivingItemList.quantityFornonLiveMaterialitem}</p>
                                                                        <p className="c-delivery-item-text fw-light" dangerouslySetInnerHTML={{ __html: nonLivingItemList.productDescFornonLiveMaterialitem }}>
                                                                            </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 col-md-4 align-self-center">
                                                                <div className="row">
                                                                    <div className="col-12 col-md-12 d-flex">
                                                                        {nonLivingItemList && nonLivingItemList.arrivalStartDateFornonLiveMaterialitem && selecteNonLivingMethodRef.current === 'shipImmediate' && (
                                                                            <p className="text-left mb-0 c-delivery-content">
                                                                                {`${formattedStartDate} ${selectedShipGroupMethodRef.current === 'Standard Ground' ? '-' : ""} ${selectedShipGroupMethodRef.current === 'Standard Ground' ? formattedEndDate : ""}`}
                                                                            </p>)}
                                                                        {nonLivingItemList && nonLivingItemList.arrivalStartDateFornonLiveMaterialitem && selecteNonLivingMethodRef.current === 'shipLater' && (
                                                                            <p className="text-left mb-0 c-delivery-content">
                                                                                {`${formattedStartDate}`}
                                                                            </p>)}

                                                                        {nonLivingItemList && nonLivingItemList.DayAirTitle ?
                                                                            <p className="text-left mb-0 c-delivery-content livShipMethod">
                                                                                {nonLivingItemList.DayAirTitle}
                                                                            </p> : ""}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                        </>
                                    )
                                })}
                            </div>

                            <div className="row g-3 mb-3 mt-3">
                                <form method="POST" name="delivery_form" onSubmit={handleSubmitContinue} id="delivery_form_id" >
                                    <div className="col-md-6 d-grid">
                                        <input name="moveToBilling" type="submit" value="Continue" className="btn btn-primary block" />
                                    </div>
                                </form>
                            </div>

                            <div className="row g-3 mb-3 mt-3">

                            </div>
                        </div>

                        <OrderSummary orderSummaryDetails={orderSummaryDetailsRef.current} myOrderBoxFix={myOrderBoxFix} handleCallBackOrderSummary={handleCallBackOrderSummary} />
                    </div>
                    <div id="checkoutSpacer"></div>
                </div>




            </div>
            {/* </div> */}
        </div>
    );
}

export default CheckoutDelivery;
